export default "__VITE_ASSET__C5wtBH4Y__"